'use strict';

/**
 * Directive: validation-messages
 * 
 * A reusable component that displays validation error messages using ng-messages.
 * Automatically shows error messages for standard validators (required, email, etc.)
 * and custom validators (like nanpPhoneNumber).
 * 
 * Usage:
 *   <input name="phoneNumber" ng-model="data.phone" nanp-phone-number />
 *   <validation-messages for="formName.phoneNumber"></validation-messages>
 * 
 * Attributes:
 *   - for: The form field to display errors for (e.g., "myForm.email")
 *   - show-when: Optional expression for when to show messages (default: field is dirty or touched)
 */
angular
    .module('App.v1.Directives')
    .directive('validationMessages', ['App.v1.Services.PhoneNumberValidation', function(phoneValidationService) {
        return {
            restrict: 'E',
            scope: {
                for: '=',
                showWhen: '=?'
            },
            template: `
                <div ng-messages="for.$error" 
                     ng-show="shouldShow()" 
                     class="validation-messages"
                     role="alert">
                    
                    <!-- Standard validators -->
                    <div ng-message="required" class="text-danger small">
                        <i class="fas fa-exclamation-triangle"></i> This field is required
                    </div>
                    <div ng-message="email" class="text-danger small">
                        <i class="fas fa-exclamation-triangle"></i> Please enter a valid email address
                    </div>
                    <div ng-message="minlength" class="text-danger small">
                        <i class="fas fa-exclamation-triangle"></i> Input is too short
                    </div>
                    <div ng-message="maxlength" class="text-danger small">
                        <i class="fas fa-exclamation-triangle"></i> Input is too long
                    </div>
                    <div ng-message="pattern" class="text-danger small">
                        <i class="fas fa-exclamation-triangle"></i> Invalid format
                    </div>
                    <div ng-message="min" class="text-danger small">
                        <i class="fas fa-exclamation-triangle"></i> Value is too small
                    </div>
                    <div ng-message="max" class="text-danger small">
                        <i class="fas fa-exclamation-triangle"></i> Value is too large
                    </div>
                    <div ng-message="url" class="text-danger small">
                        <i class="fas fa-exclamation-triangle"></i> Please enter a valid URL
                    </div>
                    <div ng-message="number" class="text-danger small">
                        <i class="fas fa-exclamation-triangle"></i> Please enter a valid number
                    </div>
                    
                    <!-- Default handler for custom validators using errorMessages collection -->
                    <div ng-message-default class="text-danger small">
                        <div ng-repeat="(errorKey, errorMessage) in for.errorMessages">
                            <i class="fas fa-exclamation-triangle"></i> {{errorMessage}}
                        </div>
                    </div>
                    
                </div>
            `,
            link: function(scope, element, attrs) {
                /**
                 * Determines when to show validation messages.
                 * By default, shows when field is dirty or touched.
                 * Can be overridden via show-when attribute.
                 */
                scope.shouldShow = function() {
                    if (angular.isDefined(scope.showWhen)) {
                        return scope.showWhen;
                    }
                    return scope.for && (scope.for.$dirty || scope.for.$touched);
                };
            }
        };
    }]);
